import { html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlEventCardProps, CardTags } from './card.types.ts';
import { getGlobalStyleSheets } from '../../global-styles';
import { ifDefined } from 'lit/directives/if-defined.js';
import classNames from 'classnames';
import { Variant } from '../enum-types.ts';

import Styles from './event-card.scss?inline';

@customElement(CardTags.EventCard)
export class AtlEventCard extends LitElement implements AtlEventCardProps {
   declare internalId?: string;
   declare internalClassName?: string;
   declare bodyClassName?: string;
   declare cardTitle?: string;
   declare imageSrc: string;
   declare imageAlt?: string;
   declare date?: string;
   declare category?: string;
   declare showDateIcon?: boolean;
   declare isHighLightCard?: boolean;
   declare categoriesPills?: string[];

   static properties = {
      internalId: { type: String },
      internalClassName: { type: String },
      bodyClassName: { type: String },
      cardTitle: { type: String },
      date: { type: String },
      category: { type: String },
      imageSrc: { attribute: 'img-src', type: String },
      imageAlt: { attribute: 'img-alt', type: String },
      showDateIcon: { attribute: 'show-date-icon', type: Boolean },
      isHighLightCard: { type: Boolean },
      categoriesPills: { attribute: 'categories-pills', type: Array },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      Styles
   ];

   renderCardCategories() {
      if (
         !(this.categoriesPills && this.categoriesPills.length > 0) &&
         !this.category
      ) {
         return nothing;
      }

      return html`
         <div class="h6 event-category">
            ${this.categoriesPills
               ? html`
                    <div class="flex inline align-items-center">
                       ${this.categoriesPills?.map(
                          (pill) =>
                             html`<atlantis-badge
                                variant=${Variant.Secondary}
                                label="${pill}"
                             ></atlantis-badge>`
                       )}
                    </div>
                 `
               : html`${this.category}`}
         </div>
      `;
   }

   renderCardDate() {
      if (!this.date) {
         return nothing;
      }

      return html`
         ${this.showDateIcon
            ? html`<i class="fa-solid fa-calendar-days event-date-icon"></i>`
            : nothing}
         <span class="event-date">${this.date}</span>
      `;
   }

   render() {
      return html` <div
         part="event-card"
         id="${ifDefined(this.internalId)}"
         class=${classNames(
            'card',
            { 'event-highlight-card': this.isHighLightCard },
            { 'event-card': !this.isHighLightCard },
            this.internalClassName
         )}
      >
         <img
            class="card-img-top"
            src=${this.imageSrc}
            alt=${ifDefined(this.imageAlt)}
         />
         <div class=${classNames('card-body', this.bodyClassName)}>
            ${this.renderCardCategories()}
            <div class="h5 card-title">${this.cardTitle}</div>
            ${this.renderCardDate()}
            <slot name="slotCardBody"></slot>
            <slot name="slotButtonContainer"></slot>
         </div>
      </div>`;
   }
}
